// Generated types for InquiriesSummaryTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { StepTaskReadAPI, StepTaskWriteAPI } from '../../llm_task/types/steptask';
import { StepTaskReadAPISchemaObject, StepTaskWriteAPISchemaObject } from '../../llm_task/types/steptask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface InquiriesSummaryTaskReadAPI extends StepTaskReadAPI {
}

export interface InquiriesSummaryTaskWriteAPI extends StepTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const InquiriesSummaryTaskReadAPISchema: z.ZodType<InquiriesSummaryTaskReadAPI> = StepTaskReadAPISchemaObject.extend({}).passthrough();

export const InquiriesSummaryTaskWriteAPISchema: z.ZodType<InquiriesSummaryTaskWriteAPI> = StepTaskWriteAPISchemaObject.extend({}).passthrough();
